module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white@3x-2c256038733e3b057d5a7197a66adfa8.png";